(function() {

// ===== 1. URGENCY BAR =====
function initUrgencyBar() {
  var bar = document.getElementById('sn-urgency-bar');
  if (!bar) return;
  var countdownEl = bar.querySelector('.sn-urgency-countdown');
  if (!countdownEl) return;
  function updateCountdown() {
    var now = new Date();
    var cutoff = new Date();
    cutoff.setHours(14, 0, 0, 0);
    if (now >= cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
    }
    var diff = cutoff - now;
    if (diff <= 0) { diff = 0; }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    countdownEl.textContent = (h > 0 ? h + 'h ' : '') + m + 'm ' + s + 's';
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);
}

// ===== 2. TRUST BADGES =====
function injectTrustBadges() {
  if (document.querySelector('.sn-trust-badges')) return;
  var atcBtn = document.querySelector('.product-form__add-button');
  if (!atcBtn) return;
  var badges = document.createElement('div');
  badges.className = 'sn-trust-badges';
  badges.innerHTML =
    '<div class="sn-trust-badge"><span class="sn-trust-badge__icon">🚚</span><span class="sn-trust-badge__label">Free UK Delivery</span></div>' +
    '<div class="sn-trust-badge"><span class="sn-trust-badge__icon">📦</span><span class="sn-trust-badge__label">Same Day Dispatch</span></div>' +
    '<div class="sn-trust-badge"><span class="sn-trust-badge__icon">⭐</span><span class="sn-trust-badge__label">60+ Years Experience</span></div>' +
    '<div class="sn-trust-badge"><span class="sn-trust-badge__icon">🔒</span><span class="sn-trust-badge__label">Secure Checkout</span></div>';
  atcBtn.parentElement.insertBefore(badges, atcBtn.nextSibling);
}

// ===== 3. STICKY ATC BAR =====
function initStickyATC() {
  if (document.querySelector('.sn-sticky-atc')) return;
  var atcBtn = document.querySelector('.product-form__add-button');
  if (!atcBtn) return;

  var title = document.querySelector('.product-meta__title, h1');
  var price = document.querySelector('.price--large .price-item--sale, .price--large .price-item--regular, .price .price-item--regular');
  var productImg = document.querySelector('.product__media img, .product-single__photo img, [data-product-single-media-wrapper] img');
  var comparePrice = document.querySelector('.price--large .price-item--regular');
  var salePrice = document.querySelector('.price--large .price-item--sale');

  var imgSrc = productImg ? (productImg.src || productImg.getAttribute('data-src') || productImg.getAttribute('data-srcset') || '') : '';
  if (imgSrc && imgSrc.indexOf(',') > -1) { imgSrc = imgSrc.split(',')[0].trim().split(' ')[0]; }
  imgSrc = imgSrc.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original)\./, '_small.');

  var titleText = title ? title.textContent.trim() : 'Product';
  var priceHTML = '';
  if (salePrice && comparePrice && salePrice.textContent !== comparePrice.textContent) {
    priceHTML = '<span class="sn-sticky-price--sale">' + salePrice.textContent.trim() + '</span> <span class="sn-sticky-price--compare">' + comparePrice.textContent.trim() + '</span>';
  } else if (price) {
    priceHTML = '<span class="sn-sticky-price">' + price.textContent.trim() + '</span>';
  }

  var sticky = document.createElement('div');
  sticky.className = 'sn-sticky-atc';
  sticky.innerHTML =
    (imgSrc ? '<img class="sn-sticky-img" src="' + imgSrc + '" alt="">' : '') +
    '<div class="sn-sticky-info"><div class="sn-sticky-title">' + titleText + '</div><div class="sn-sticky-price-wrap">' + priceHTML + '</div></div>' +
    '<button class="sn-sticky-btn" onclick="(function(){var b=document.querySelector(\'.product-form__add-button\');if(b){b.click();}})()">Add to Cart</button>';
  document.body.appendChild(sticky);

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    });
  }, { threshold: 0 });
  observer.observe(atcBtn);
}

// ===== 4. FIX DELIVERY COUNTDOWN (weekend fix) =====
// On weekends, the green dispatch box shows incorrect same-day dispatch
// and gives a different date to the white delivery box.
// This function corrects the green box to match the white box's delivery date.
function fixDeliveryCountdown() {
  var now = new Date();
  var day = now.getDay(); // 0=Sun, 6=Sat
  if (day !== 0 && day !== 6) return; // only run on weekends

  var isT = now.getHours() < 14; // before/after 2pm cutoff
  var label = document.querySelector('.sn-cd-label');
  var msg = document.querySelector('.sn-cd-msg');
  var dateEl = document.querySelector('.sn-cd-date strong');

  // Calculate correct delivery date using same logic as the white box:
  // Before 2pm: +2 working days; After 2pm: +3 working days
  var deliveryDate = new Date(now);
  deliveryDate.setHours(0, 0, 0, 0);
  deliveryDate.setDate(deliveryDate.getDate() + (isT ? 2 : 3));
  // Skip weekends
  while (deliveryDate.getDay() === 0 || deliveryDate.getDay() === 6) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }

  var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var dateStr = weekdays[deliveryDate.getDay()] + ', ' + deliveryDate.getDate() + ' ' + months[deliveryDate.getMonth()];

  // Update green box to show correct info
  if (label) label.textContent = 'Dispatches Next Working Day';
  if (msg) msg.textContent = isT ? 'Order now — dispatched tomorrow' : 'Order now — dispatched Monday';
  if (dateEl) dateEl.textContent = dateStr;
}

function init() {
  initUrgencyBar();
  injectTrustBadges();
  initStickyATC();
  fixDeliveryCountdown();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

})();